import { Router, Private, Route } from '@redwoodjs/router'

const Routes = () => {
  return (
    <Router>
      <Route path="/" page={HomePage} name="home" />
      <Private unauthenticated="home">
        <Route path="/dashboard" page={DashboardPage} name="dashboard" />
        <Route path="/companies/new" page={NewCompanyPage} name="newCompany" />
        <Route path="/companies/{companyId}/edit" page={EditCompanyPage} name="editCompany" />
        <Route path="/companies/{companyId}" page={CompanyPage} name="company" />
        <Route path="/companies/{companyId}/asks" page={AsksPage} name="asks" />
        <Route path="/companies/{companyId}/asks/new" page={NewAskPage} name="newAsk" />
        <Route path="/companies/{companyId}/asks/{askId}" page={AskPage} name="ask" />
        <Route path="/companies/{companyId}/asks/{askId}/edit" page={EditAskPage} name="editAsk" />
        <Route path="/companies/{companyId}/asks/{askId}/contribution/new" page={NewContributionPage} name="newContribution" />
        <Route path="/companies/{companyId}/asks/{askId}/contribution/{contributionId}" page={ContributionPage} name="contribution" />
        <Route path="/companies/{companyId}/asks/{askId}/contribution/{contributionId}/edit" page={EditContributionPage} name="editContribution" />
        <Route path="/companies/{companyId}/investors" page={InvestorsPage} name="investors" />
        <Route path="/companies/{companyId}/investors/new" page={NewInvestorPage} name="newInvestor" />
        <Route path="/companies/{companyId}/investors/{investorId}" page={InvestorPage} name="investor" />
        <Route path="/companies/{companyId}/investors/{investorId}/edit" page={EditInvestorPage} name="editInvestor" />
        <Route path="/companies/{companyId}/founders" page={FoundersPage} name="founders" />
        <Route path="/companies/{companyId}/founders/new" page={NewFounderPage} name="newFounder" />
        <Route path="/companies/{companyId}/founders/{founderId}" page={FounderPage} name="founder" />
        <Route path="/companies/{companyId}/founders/{founderId}/edit" page={EditFounderPage} name="editFounder" />
      </Private>
      <Route notfound page={NotFoundPage} />
    </Router>
  )
}

export default Routes

// <Route path="/users/new" page={NewUserPage} name="newUser" />
// <Route path="/users/{id}/edit" page={EditUserPage} name="editUser" />
// <Route path="/users/{id}" page={UserPage} name="user" />
// <Route path="/users" page={UsersPage} name="users" />
